import _styled4 from "styled-components";
import _styled3 from "styled-components";
import _styled2 from "styled-components";
import _styled from "styled-components";
var _excluded = ["isSelected", "isDisabled", "children"],
    _excluded2 = ["isDisabled", "children"],
    _excluded3 = ["className", "style", "isSelected", "isHighlighted", "isMultiple", "isDisabled", "text", "subtext"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from '@adsk/alloy-checkbox';
import { stylePropType } from '@adsk/alloy-helpers';
import Icon from '@adsk/alloy-icon';
import theme from '@adsk/alloy-theme';

var Label = function Label(_ref) {
  var isSelected = _ref.isSelected,
      isDisabled = _ref.isDisabled,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(_StyledDiv, _extends({}, props, {
    $_css: [theme.typography.ellipsis, theme.typography.bodyMedium, _objectSpread(_objectSpread({
      color: theme.colors.charcoal900
    }, isSelected && !isDisabled && theme.typography.bodyMediumBold), isDisabled && {
      color: theme.colors.charcoal500
    })]
  }), children);
};

var Subtext = function Subtext(_ref2) {
  var isDisabled = _ref2.isDisabled,
      children = _ref2.children,
      props = _objectWithoutProperties(_ref2, _excluded2);

  return /*#__PURE__*/React.createElement(_StyledDiv2, _extends({}, props, {
    $_css2: [theme.typography.ellipsis, theme.typography.bodyMedium, _objectSpread({
      color: theme.colors.charcoal700
    }, isDisabled && {
      color: theme.colors.charcoal500
    })]
  }), children);
};

var MenuItem = /*#__PURE__*/React.forwardRef(function (_ref3, ref) {
  var className = _ref3.className,
      style = _ref3.style,
      isSelected = _ref3.isSelected,
      isHighlighted = _ref3.isHighlighted,
      isMultiple = _ref3.isMultiple,
      isDisabled = _ref3.isDisabled,
      label = _ref3.text,
      subtext = _ref3.subtext,
      props = _objectWithoutProperties(_ref3, _excluded3);

  return /*#__PURE__*/React.createElement(_StyledLi, _extends({
    ref: ref,
    className: className
  }, props, {
    $_css3: [_objectSpread(_objectSpread(_objectSpread({
      display: 'flex',
      alignItems: 'flex-start',
      padding: subtext ? '8px 16px' : '10px 16px'
    }, !isDisabled && {
      cursor: 'pointer'
    }), isHighlighted && !isDisabled && {
      backgroundColor: theme.colors.charcoal050
    }), {}, {
      '&:active': _objectSpread({}, !isDisabled && {
        backgroundColor: theme.colors.charcoal100
      })
    }, isSelected && !isMultiple && {
      backgroundColor: theme.colors._adskBlue100Alpha
    }), style]
  }), isMultiple && /*#__PURE__*/React.createElement(Checkbox, {
    checked: isSelected,
    style: {
      marginRight: 8,
      marginTop: 2
    },
    readOnly: true
  }), /*#__PURE__*/React.createElement(_StyledDiv3, {
    $_css4: [theme.typography.ellipsis, {
      flex: 1
    }]
  }, label && /*#__PURE__*/React.createElement(Label, {
    isDisabled: isDisabled,
    isSelected: isSelected
  }, label), subtext && /*#__PURE__*/React.createElement(Subtext, {
    isDisabled: isDisabled
  }, subtext)), !isDisabled && isSelected && !isMultiple && /*#__PURE__*/React.createElement(Icon, {
    type: Icon.TYPES.CHECKMARK,
    size: 24,
    style: {
      color: theme.colors.adskBlue700
    }
  }));
});
MenuItem.displayName = 'MenuOption';
MenuItem.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,

  /** Class applied to the root element */
  className: PropTypes.string,

  /** Whether menu option is currently selected */
  isSelected: PropTypes.bool,

  /** Whether menu option is currently highlighted.  Used when cursor navigation */
  isHighlighted: PropTypes.bool,

  /** Whether menu option is in a multi select */
  isMultiple: PropTypes.bool,

  /** Whether menu option is disabled */
  isDisabled: PropTypes.bool,

  /** Primary content */
  text: PropTypes.node,

  /** Secondary content */
  subtext: PropTypes.node
};
export default MenuItem;

var _StyledDiv = _styled("div").withConfig({
  displayName: "MenuItem___StyledDiv",
  componentId: "sc-11euy9m-0"
})(["", ""], function (p) {
  return p.$_css;
});

var _StyledDiv2 = _styled("div").withConfig({
  displayName: "MenuItem___StyledDiv2",
  componentId: "sc-11euy9m-1"
})(["", ""], function (p) {
  return p.$_css2;
});

var _StyledLi = _styled("li").withConfig({
  displayName: "MenuItem___StyledLi",
  componentId: "sc-11euy9m-2"
})(["", ""], function (p) {
  return p.$_css3;
});

var _StyledDiv3 = _styled("div").withConfig({
  displayName: "MenuItem___StyledDiv3",
  componentId: "sc-11euy9m-3"
})(["", ""], function (p) {
  return p.$_css4;
});
//# sourceMappingURL=MenuItem.js.map